export default "__VITE_ASSET__ecede8be__"